import { render, staticRenderFns } from "./SellProductPlus.vue?vue&type=template&id=d8922dac&scoped=true"
import script from "./SellProductPlus.vue?vue&type=script&lang=js"
export * from "./SellProductPlus.vue?vue&type=script&lang=js"
import style0 from "./SellProductPlus.vue?vue&type=style&index=0&id=d8922dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8922dac",
  null
  
)

export default component.exports